import { render, staticRenderFns } from "./Changelog.vue?vue&type=template&id=44ad5120"
import script from "./Changelog.vue?vue&type=script&lang=js"
export * from "./Changelog.vue?vue&type=script&lang=js"
import style0 from "./Changelog.vue?vue&type=style&index=0&id=44ad5120&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports